module.exports = __webpack_public_path__ + "static/media/step-2a-sandcastle.b425e0e4.gif";